var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [_vm._v(" Manage Protected URLs ")]),
          _c(
            "gg-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "d-flex",
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c(
                        "gg-btn",
                        {
                          attrs: {
                            secondary: "",
                            disabled: !_vm.upEnabled
                          },
                          on: {
                            click: function click($event) {
                              return _vm.loadDirs(_vm.parent)
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-1",
                              attrs: {
                                size: "20"
                              }
                            },
                            [_vm._v("mdi-arrow-up")]
                          ),
                          _vm._v(" Up One Level ")
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("v-data-table", {
                        attrs: {
                          headers: _vm.headers,
                          items: _vm.children,
                          loading: _vm.loading,
                          "items-per-page": 100,
                          "hide-default-footer": ""
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.path",
                            fn: function fn(_ref) {
                              var item = _ref.item
                              return [
                                _c(
                                  "v-icon",
                                  {
                                    staticClass: "mr-2",
                                    attrs: {
                                      size: "20",
                                      color: "primary"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " mdi-" +
                                        _vm._s(
                                          _vm.hasAuth(item)
                                            ? "folder-lock"
                                            : "folder"
                                        ) +
                                        " "
                                    )
                                  ]
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "#"
                                    },
                                    on: {
                                      click: function click($event) {
                                        $event.preventDefault()
                                        return _vm.loadDirs(item.path)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.dirName(item.path)) + " "
                                    )
                                  ]
                                )
                              ]
                            }
                          },
                          {
                            key: "item.private",
                            fn: function fn(_ref2) {
                              var item = _ref2.item
                              return [
                                _vm.hasAuth(item)
                                  ? [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            size: "18",
                                            color: "primary"
                                          }
                                        },
                                        [_vm._v("mdi-lock")]
                                      ),
                                      _vm._v(" Yes ")
                                    ]
                                  : [_vm._v("No")]
                              ]
                            }
                          },
                          {
                            key: "item.manage",
                            fn: function fn(_ref3) {
                              var item = _ref3.item
                              return [
                                _c(
                                  "v-menu",
                                  {
                                    attrs: {
                                      "offset-y": ""
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function fn(_ref4) {
                                            var on = _ref4.on,
                                              attrs = _ref4.attrs
                                            return [
                                              _c(
                                                "gg-btn",
                                                _vm._g(
                                                  _vm._b(
                                                    {},
                                                    "gg-btn",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _vm._v(" Manage "),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "ml-1"
                                                    },
                                                    [_vm._v("mdi-chevron-down")]
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  },
                                  [
                                    _c(
                                      "v-list",
                                      [
                                        _c(
                                          "v-list-item",
                                          {
                                            on: {
                                              click: function click($event) {
                                                return _vm.openAddUser(
                                                  item.path
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(" Add User ")
                                            ])
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item",
                                          {
                                            on: {
                                              click: function click($event) {
                                                return _vm.openManageUsers(
                                                  item.path
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(" Manage Users ")
                                            ])
                                          ],
                                          1
                                        ),
                                        _vm.hasAuth(item)
                                          ? _c(
                                              "v-list-item",
                                              {
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.openRemove(item)
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(" Disable Protection ")
                                                ])
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("manage-users-modal", {
        attrs: {
          path: _vm.selectedPath
        },
        on: {
          close: function close($event) {
            _vm.selectedPath = ""
          }
        },
        model: {
          value: _vm.manageUsersModal,
          callback: function callback($$v) {
            _vm.manageUsersModal = $$v
          },
          expression: "manageUsersModal"
        }
      }),
      _c("add-user-modal", {
        attrs: {
          path: _vm.selectedPath
        },
        on: {
          close: function close($event) {
            _vm.selectedPath = ""
          }
        },
        model: {
          value: _vm.addUserModal,
          callback: function callback($$v) {
            _vm.addUserModal = $$v
          },
          expression: "addUserModal"
        }
      }),
      _c("remove-auth-modal", {
        attrs: {
          path: _vm.selectedPath,
          authname: _vm.selectedAuth
        },
        on: {
          close: function close($event) {
            _vm.selectedPath = ""
          },
          removed: _vm.loadCurrent
        },
        model: {
          value: _vm.removeModal,
          callback: function callback($$v) {
            _vm.removeModal = $$v
          },
          expression: "removeModal"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }